import React from "react";

export default React.createContext({
    nbPage: 0,
    setNbPage: () => {},
    filters: [],
    updateFilters: () => {}
});
